import React, { useEffect } from 'react';
import TemplateData, { isMobileHeaderExp } from '../utility/getTemplateData';
import { Row, Col, BodyText, Link } from '@paypalcorp/pp-react';
import ConfirmationMyAccount from './ConfirmationMyAccount';
import ConfirmationSocialShare from './ConfirmationSocialShare';
import ConfirmationTransactionId from './ConfirmationTransactionId';
import OfferConfirmation from '../components/offerConfirmation';
import PropTypes from 'prop-types';
import SignUpAlert from '../components/guest/SignUpAlert';
import VoucherFlowDisclaimer from '../components/voucherFlowDisclaimer';
import ConfirmationRedirect from './ConfirmationRedirect';
import { endCustomCPLTrackingForConfirmationPage } from '../utility/cpl';
import {
  isInContext,
  onComplete,
  closeWindow,
} from '../utility/inContextDonation';
import { isGN, isGNC } from '../utility/externalIntegrationUtils';
import CloseButton from '../components/CloseButton';

function ConfirmationView(props) {
  const {
    accountLink,
    accountMessage,
    autoRedirect,
    autoRedirectUrl,
    autoRedirectMethod,
    engamentText,
    footer,
    handleRedirect,
    hostedButtonId,
    illustration,
    isSignUp,
    isVoucherFlow,
    message,
    messages,
    offerProgram,
    orgName,
    postBackData,
    returnTo,
    returnText,
    signUpProps,
    showMyAccount,
    syncReturnUrl,
    txnId,
    personalizedMessages,
    isExternalFlow,
  } = props;

  useEffect(() => {
    endCustomCPLTrackingForConfirmationPage();
  }, []);

  useEffect(() => {
    onComplete(postBackData);
  }, []);

  function showSocialShare() {
    if (TemplateData.socialSharePreference) {
      return (
        <ConfirmationSocialShare
          hostedButtonId={hostedButtonId}
          orgName={orgName}
          messages={messages}
          email={TemplateData.donationEmail}
          personalizedMessages={personalizedMessages}
        />
      );
    }
    return null;
  }

  function confirmationClass() {
    let className = '';
    if (isGN() || isGNC()) {
      className = 'gn_donate_wrapper ';
    } else {
      className = 'donate_wrapper confirmation';
    }
    if (isMobileHeaderExp()) {
      className += 'mobile_view ';
    }

    return className;
  }

  function handleClose() {
    if (isInContext()) {
      closeWindow();
    }
  }

  return (
    <div>
      {isSignUp && <SignUpAlert {...signUpProps} />}
      <div className={confirmationClass()}>
        {isExternalFlow && <CloseButton />}
        <Row>
          <Col xs={12}>{illustration}</Col>
        </Row>
        <div className="success_content">
          {message}

          {isExternalFlow && personalizedMessages.success_subheader ? (
            <BodyText className="text-center success_subheader">
              {personalizedMessages.success_subheader}
            </BodyText>
          ) : null}

          {isVoucherFlow && (
            <OfferConfirmation offerProgram={offerProgram} txnId={txnId} />
          )}

          {isVoucherFlow && <VoucherFlowDisclaimer />}

          {showSocialShare()}

          <ConfirmationTransactionId transactionId={txnId} />

          {showMyAccount && (
            <ConfirmationMyAccount
              engamentText={engamentText}
              message={accountMessage}
              link={accountLink}
            />
          )}

          {isInContext() ? (
            <div className="text-center">
              <Link href="#" onClick={handleClose}>
                {personalizedMessages.success_returnButton}
              </Link>
            </div>
          ) : null}
        </div>
      </div>
      {!isInContext() && autoRedirect && autoRedirectUrl && (
        <ConfirmationRedirect
          autoRedirectMethod={autoRedirectMethod}
          autoRedirectUrl={autoRedirectUrl}
          handleRedirect={handleRedirect}
          orgName={orgName}
          postBackData={postBackData}
          returnText={returnText}
          returnTo={returnTo}
          syncReturnUrl={syncReturnUrl}
        />
      )}
      {footer}
    </div>
  );
}

ConfirmationView.propTypes = {
  accountLink: PropTypes.string,
  accountMessage: PropTypes.string,
  autoRedirectMethod: PropTypes.string,
  autoRedirect: PropTypes.bool,
  autoRedirectUrl: PropTypes.string,
  engamentText: PropTypes.string,
  footer: PropTypes.object,
  handleRedirect: PropTypes.func,
  hostedButtonId: PropTypes.string,
  isVoucherFlow: PropTypes.bool,
  illustration: PropTypes.object,
  isSignUp: PropTypes.bool,
  message: PropTypes.object,
  messages: PropTypes.object,
  offerProgram: PropTypes.object,
  orgName: PropTypes.string,
  postBackData: PropTypes.object,
  redirect: PropTypes.func,
  returnTo: PropTypes.string,
  returnText: PropTypes.string,
  showMyAccount: PropTypes.bool,
  signUpProps: PropTypes.object,
  syncReturnUrl: PropTypes.string,
  txnId: PropTypes.string,
  personalizedMessages: PropTypes.object,
  isExternalFlow: PropTypes.bool,
};

export default ConfirmationView;
